var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"hidden","name":"pageRouter","value":"detail/information"}}),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.detailData.articleContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }